import styled from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => theme.below.tablet`
    margin-top: ${theme.spaces[5]}px;
  `}

  .description-title,
  .description-subtitle {
    max-width: 820px;
  }
`
